import { render } from "./Grid.vue?vue&type=template&id=2649d84f"
import script from "./Grid.vue?vue&type=script&lang=ts"
export * from "./Grid.vue?vue&type=script&lang=ts"
script.render = render

export default script